import { filtersHelper } from '@/utils';

export const catalogModel = (data = {}) => ({
    uuid: data.uuid || '',
    description: data.description || '',
    name: data.name || '',
    catalogSubcategoryUUID: data.catalog_subcategory?.uuid || '',
    catalogSubcategory: data.catalog_subcategory || null,
    catalogSubcategoryName: data.catalog_subcategory?.name || '',
    companyUUID: data.company?.uuid || '',
    company: data.company || null,
    companyName: data.company?.name || '',
    picUserUUID:  data.pic_user?.uuid || '',
    picUser: data.pic_user || null,
    picUserName: data.pic_user ? (data.pic_user?.first_name + " " + data.pic_user?.last_name) || '' :null,
    pdfUrl: data.pdf_path || '',
    isActive: data.is_active == null ? true : data.is_active === true || Number(data.is_active) === 1,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
});
